export const processUserForDisplay = (id, members) => {
    return members.find((obj) => {
        return obj.id === id;
    })
};